import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import type { DeleteProfessionalDescriptionField } from '../types/SharedActions';

import { updateLocalStorage } from './updateLocalStorage';

export const deleteProfessionalExperienceFields = (
  doc: CoverLetterDocumentType,
  value: DeleteProfessionalDescriptionField['value']
): void => {
  const { index, subIndex } = value;
  const professionalExperienceDoc = [...(doc.professionalExperience ?? [])];

  const professionalExperience = professionalExperienceDoc[index];

  if (!professionalExperience) return;

  const descriptions = professionalExperience.descriptions;

  if (!descriptions) return;

  professionalExperience.descriptions = descriptions.filter(
    (_, index) => index !== subIndex
  );

  updateLocalStorage(`professionalExperience`, professionalExperienceDoc);
};
